import {
  GET_RECEIPTS,
  GET_RECEIPTS_SUCCESS,
  GET_RECEIPTS_ERROR,
  CREATE_RECEIPT,
  CREATE_RECEIPT_ERROR,
  CREATE_RECEIPT_SUCCESS,
  EXPORT_RECEIPTS,
  EXPORT_RECEIPTS_ERROR,
  EXPORT_RECEIPTS_SUCCESS,
  GET_RECEIPT_TYPES,
  GET_RECEIPT_TYPES_SUCCESS,
  GET_RECEIPT_TYPES_ERROR,
  CREATE_RECEIPT_TYPES,
  CREATE_RECEIPT_TYPES_SUCCESS,
  CREATE_RECEIPT_TYPES_ERROR,
} from "./actionTypes"

export const getReceipts = (payload) => ({
  type: GET_RECEIPTS,
  payload: payload
})

export const getReceiptsSuccess = (Receipt, meta = {}) => ({
  type: GET_RECEIPTS_SUCCESS,
  payload: Receipt,
  meta,
})

export const getReceiptsError = (error) => ({
  type: GET_RECEIPTS_ERROR,
  payload: error
})

export const createReceipt = (payload, brandId) => ({
  type: CREATE_RECEIPT,
  payload: payload,
  brandId: brandId
})

export const createReceiptSuccess = (Receipt) => ({
  type: CREATE_RECEIPT_SUCCESS,
  payload: Receipt
})

export const createReceiptError = (error) => ({
  type: CREATE_RECEIPT_ERROR,
  payload: error
})

export const exportReceipts = (payload, filename) => ({
  type: EXPORT_RECEIPTS,
  payload: payload,
  filename: filename
})

export const exportReceiptsSuccess = (receipts, filename) => ({
  type: EXPORT_RECEIPTS_SUCCESS,
  payload: receipts,
  filename: filename
})

export const exportReceiptsError = (error) => ({
  type: EXPORT_RECEIPTS_ERROR,
  payload: error
})

export const getReceiptTypes = (payload) => ({
  type: GET_RECEIPT_TYPES,
  payload: payload
})

export const getReceiptTypesSuccess = (receiptTypes) => ({
  type: GET_RECEIPT_TYPES_SUCCESS,
  payload: receiptTypes
})

export const getReceiptTypesError = (error) => ({
  type: GET_RECEIPT_TYPES_ERROR,
  payload: error
})

export const createReceiptTypes = (payload) => {
  return {
    type: CREATE_RECEIPT_TYPES,
    payload: payload,
  }
}

export const createReceiptTypesSuccess = (payload) => ({
  type: CREATE_RECEIPT_TYPES_SUCCESS,
  payload: payload
})

export const createReceiptTypesError = (error) => ({
  type: CREATE_RECEIPT_TYPES_ERROR,
  payload: error
})
